import React from 'react'

const HistoryCard = () => {
  return (
    <div style={{
        width:"30%",
        border:"1px solid",
        textAlign:"left",
        padding:"5px 10px"
    }}>
        <h3>title</h3>
        <p>time</p>
        <p style={{textAlign:"justify"}}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. 
            Aspernatur odit doloribus numquam expedita 
            iusto recusandae autem vero ad, corrupti nisi 
            natus mollitia rerum aliquam laudantium? 
            Itaque iusto eius deserunt sint!
        </p>

    </div>
  )
}

export default HistoryCard